import React from "react";
import "./ModalList.scss";

interface IList {
    textList: string[];
}
const ModalList = (props: IList) => {
    // Remueve de la lista valores vacios y saltos de linea.
    const textList = props.textList.filter(function (e) {
        return e.replace(/(\r\n|\n|\r)/gm, "");
    });

    return (
        <>
            {textList.map((text: string, index) => {
                return (
                    <div className="a-list">
                        <div className="a-list__index">{index + 1}</div>
                        <div className="a-list__text">{text}</div>
                    </div>
                );
            })}
        </>
    );
};

export default ModalList;
